// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__G-2x3","description":"PatientConsentPreview_description__1QIlr"};